import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFloppyDisk1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFloppyDisk1"><Path d="M3.5 3.5H17.5L20.5 6.5V20.5H3.5V3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 3.5V8.5H16.5V3.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 20.5V12.5H16.5V20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFloppyDisk1;
